import React, { useEffect, useState } from "react";
import { FaDownload, FaInstagram, FaLinkedin, FaSearch, FaWhatsapp, FaYoutube } from "react-icons/fa";
import { BiMenuAltRight } from "react-icons/bi";
import "./Header.css";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../redux/actions/userAction";
// import { Link } from 'react-router-dom'/

const Header = () => {

  const [isHide, setisHide] = useState(true);
  const [isHideSearch, setisHideSearch] = useState(true);

  const searchHandle = () => {
    let node = document.getElementById("search")
    if (isHideSearch) {
      node.classList.remove("hideSearch");
      node.classList.add("showSearch");
      setisHideSearch(false)
    } else {
      node.classList.remove("showSearch");
      node.classList.add("hideSearch");
      setisHideSearch(true)

    }
  }

  const menuHandler = (e) => {
    if (isHide) {
      document
        .getElementsByClassName("menuContainer")[0]
        .classList.remove("hide");
      document.getElementsByClassName("menuContainer")[0].classList.add("show");
      setisHide(false);
    } else {
      document.getElementsByClassName("menuContainer")[0].classList.add("hide");
      document
        .getElementsByClassName("menuContainer")[0]
        .classList.remove("show");

      setisHide(true);
    }
  };
  //  logout ---------------------------------------------------
  const { user, loading, isAuthenticated } = useSelector(state => state.user)
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {

    if (loading === false) {
      if (isAuthenticated === false) {
        navigate("/login");
      }
    }

  }, [dispatch, isAuthenticated]);


  const logoutHandle = () => {
    dispatch(logout())
  }

  return (
    <div className="HeaderContainerMain">
      <header>
        <div className="HeaderContainer bottomSpace">
          <div className="logoBox">
            {/* <img
              src={require('../images/petroseLogo.jpg')}
              alt="logo"
              style={{mixBlendMode:'darken'}}
            /> */}

            <h3>Banwari Portal</h3>
          </div>
          <div className="linkBox">
            <Link to={"/"} className="activ e ">
              CREATE DOCUMENTS
            </Link >
            {/* <a  to={"/products"}>Products</a > */}
            <Link to={"/all-coa"}>ALL DOCUMENTS</Link >
            <button onClick={logoutHandle} className="logOutbtn">Log out</button >

            {/* <Link  to={"/about"}>About us</Link > */}
            {/* <Link  to={"contact"}>Contact us</Link > */}
            {/* <a href={require('../images/Brochure.pdf')} download={'petrose'} className="BroBtn"><FaDownload/>Brochure</a> */}
          </div>

          <div onClick={() => menuHandler()} className="menu">
            <BiMenuAltRight />
          </div>
        </div>


        <div className="menuContainer hide">
          <div>
            <Link onClick={() => menuHandler()} to={'/'} className="activ e">
              CREATE DOCUMENTS
            </Link>
            <Link to={"/all-coa"}>ALL DOCUMENTS</Link >
            <button onClick={logoutHandle} className="logOutbtn">Log out</button >
            {/* <Link onClick={() => menuHandler()} to={"/products"}>Products</Link> */}
            {/* <Link onClick={() => menuHandler()} to={"/about"}>About us</Link> */}
            {/* <Link onClick={() => menuHandler()} to={"/contact"}>Contact us</Link> */}
            {/* <a href={require('../images/Brochure.pdf')} download={'petrose'} className="BroBtn"><FaDownload/>Brochure</a> */}
          </div>

          {/* <div className="iconBoxx">
         
            <a href="https://www.instagram.com/invites/contact/?i=1eyki4m3i00vf&utm_content=q05ecy3" target="_blank">
              <FaInstagram />
            </a>
            <a href="https://youtube.com/@sauravkori217" target="_blank">
              <FaYoutube />
            </a>
            <a
              rel="noreferrer"
              target="_blank"
              href={"https://wa.me/72918 54677"}
            >
              <FaWhatsapp />
            </a>
            
          </div> */}
        </div>
      </header>
    </div>
  );
};

export default Header;
